import React from "react";
import { useSOC } from "../context/SOCContext";
import { DataTable } from "../../common/DataTable";
import { StatusBadge } from "../ui/Badges";
import ApiLoader from "../../ui/ApiLoader";
import { EVENT_SOURCES, EVENT_TYPES } from "../data/mockData";

const Events = () => {
  const { events, assets, loading, errors } = useSOC();

  const uniqueUsers = [...new Set(events.map((e) => e.user).filter(Boolean))];
  const uniqueAssetNames = [...new Set(assets.map((a) => a.name).filter(Boolean))];

  const columns = [
    {
      id: "timestamp",
      accessorFn: (r) => r.timestamp,
      header: "Timestamp",
      enableSorting: false,
      cell: ({ row }) => <span>{new Date(row.original.timestamp).toLocaleString()}</span>,
    },
    {
      id: "eventId",
      accessorFn: (r) => r.eventId,
      header: "Event ID",
      enableSorting: false,
      meta: { filter: { variant: "text", label: "Event ID", placeholder: "Search event ID" } },
      cell: ({ row }) => <span>{row.original.eventId}</span>,
    },
    {
      id: "type",
      accessorFn: (r) => r.type,
      header: "Event Type",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "Event Type",
          placeholder: "All types",
          options: EVENT_TYPES.map((v) => ({ value: v, label: v })),
        },
      },
      cell: ({ row }) => <span>{row.original.type}</span>,
    },
    {
      id: "source",
      accessorFn: (r) => r.source,
      header: "Source",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "Source",
          placeholder: "All sources",
          options: EVENT_SOURCES.map((v) => ({ value: v, label: v })),
        },
      },
      cell: ({ row }) => <span>{row.original.source}</span>,
    },
    {
      id: "sourceIp",
      accessorFn: (r) => r.sourceIp,
      header: "Source IP",
      enableSorting: false,
      meta: { filter: { variant: "text", label: "Source IP", placeholder: "Search source IP" } },
      cell: ({ row }) => <span>{row.original.sourceIp}</span>,
    },
    {
      id: "user",
      accessorFn: (r) => r.user,
      header: "User",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "User",
          placeholder: "All users",
          options: uniqueUsers.map((v) => ({ value: v, label: v })),
        },
      },
      cell: ({ row }) => <span>{row.original.user}</span>,
    },
    {
      id: "assetName",
      accessorFn: (r) => r.assetName,
      header: "Asset",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "Asset",
          placeholder: "All assets",
          options: uniqueAssetNames.map((v) => ({ value: v, label: v })),
        },
      },
      cell: ({ row }) => <span>{row.original.assetName}</span>,
    },
    {
      id: "action",
      accessorFn: (r) => r.action,
      header: "Action",
      enableSorting: false,
      cell: ({ row }) => <span>{row.original.action}</span>,
    },
    {
      id: "result",
      accessorFn: (r) => r.result,
      header: "Result",
      enableSorting: false,
      cell: ({ row }) => <StatusBadge status={row.original.result} />,
    },
    {
      id: "severity",
      accessorFn: (r) => r.severity,
      header: "Severity",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "Severity",
          placeholder: "All severities",
          options: ["critical", "high", "medium", "low"].map((v) => ({ value: v, label: v })),
        },
      },
      cell: ({ row }) => <StatusBadge status={row.original.severity} />,
    },
  ];

  if (loading.events && events.length === 0) {
    return <ApiLoader variant="spinner" label="Loading Event Log..." className="py-20" />;
  }

  return (
    <DataTable
      columns={columns}
      data={events}
      getRowId={(r) => String(r.eventId)}
      emptyMessage={errors.events || "No records found"}
      enableColumnVisibility={false}
      enableColumnResizing
      enableColumnFilters
      maxBodyHeight="65vh"
    />
  );
};

export default Events;
